/** @flow */

import type { AdvisorActivityFilters } from "@modules/management/types";
import { transformFilters, OPERATORS } from "@transformers/request";

const isNotANumber = value => isNaN(value);

export const transformAdvisorSearch = ({ phrase }: Object) =>
  isNotANumber(phrase) ? { last_name: phrase } : { id: phrase };

export const transformAdvisorActivitySearch = (filters: AdvisorActivityFilters) => {
  let transformedFilters = transformFilters(
    {
      interactionSource: filters.interactionType,
      clientId: filters.clientId,
      createdAt: filters.from,
    },
    {
      interaction_source: OPERATORS.EQUALS,
      client_id: OPERATORS.EQUALS,
      created_at: OPERATORS.GREATER_THAN,
    },
  );

  const transformedRangeFiltersHelper = transformFilters(
    {
      createdAt: filters.to,
    },
    {
      created_at: OPERATORS.LESS_THAN,
    },
  );

  transformedFilters += `,${transformedRangeFiltersHelper}`;

  return transformedFilters;
};
